import { makeStyles } from '@material-ui/core/styles';
import { createRoot, createFormLayout } from '../common';

const useStyles = makeStyles((theme) => ({
  root: createRoot(theme),
  layout: createFormLayout(theme),
  emailGrid: {
    borderTop: `1px solid ${theme.palette.grey6}`,
    margin: `32px 16px 0`,
  },
  emailCopy: {
    margin: `24px 0 8px -16px !important`,
  },
  fccActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '32px !important',
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column-reverse',
      paddingTop: '8px !important',
    },
  },
  fccButtonCancel: {
    margin: '0 24px 0 0',
    [theme.breakpoints.only('xs')]: {
      margin: '24px 0 0 0',
    },
  },
  fccButtonSubmit: {
    float: 'unset !important',
    minWidth: '125px',
    width: 'auto !important',
  },
  gridContainer: {
    '& .MuiFormLabel-root': {
      fontSize: theme.typography.pxToRem(18),
    },
  },
}));

export default useStyles;
